import * as React from 'react';
import Link from 'gatsby-link';
import {
  AppBar,
  Button,
  Divider,
  Drawer,
  Hidden,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Toolbar,
  withStyles,
  WithStyles,
} from 'material-ui';
import MenuIcon from '@material-ui/icons/Menu';

import { blueBorderValue, LinkCustom, scifiBackground, scifiText } from '../../utils/styles';
import { Breakpoints } from '../../utils/responsive';

const styles = {
  toolbar: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  link: {
    ...LinkCustom,
  },
  homeButton: {
    [Breakpoints.Tablet]: {
      fontSize: '1.3rem',
    },
    fontFamily: "'Audiowide', cursive",
    border: blueBorderValue,
    whiteSpace: 'nowrap',
  },
  list: {
    listStyleType: 'none',
    display: 'flex',
    justifyContent: 'space-around',
  },
  listItem: {
    display: 'inline',
    marginLeft: '0.5rem',
    marginTop: '0.1rem',
    marginBottom: '0.1rem',
  },
  drawer: {
    borderLeft: blueBorderValue,
    backgroundColor: '#000000',
    width: '150px',
  },
  divider: {
    ...scifiBackground,
  },
  menuLink: {
    ...scifiText,
  },
};

interface NavLink {
  text: string;
  href: string;
}

const links: NavLink[] = [
  {
    text: 'Blog',
    href: '/blog',
  },
  {
    text: 'Contact',
    href: '/contact',
  },
];

interface TopNavProps extends WithStyles<keyof typeof styles> {}

interface TopNavState {
  drawerOpen: boolean;
}

export class TopNavBase extends React.PureComponent<TopNavProps, TopNavState> {
  state: TopNavState = {
    drawerOpen: false,
  };

  toggleDrawer = () => {
    this.setState((prevState: TopNavState) => ({ drawerOpen: !prevState.drawerOpen }));
  };

  render() {
    const { classes } = this.props;
    return (
      <AppBar>
        <Toolbar className={classes.toolbar}>
          <Link to="/" className={classes.link}>
            <Button size="large" color="secondary" className={classes.homeButton}>
              Apheleia Press
            </Button>
          </Link>
          <div>
            <Hidden implementation="css" smUp>
              <IconButton color="secondary" onClick={this.toggleDrawer}>
                <MenuIcon />
              </IconButton>
              <Drawer
                anchor="right"
                open={this.state.drawerOpen}
                onClose={this.toggleDrawer}
                classes={{ paper: classes.drawer }}
              >
                <List component="nav" disablePadding>
                  {links.map(link => (
                    <React.Fragment key={link.href}>
                      <Link to={link.href} className={classes.link} onClick={this.toggleDrawer}>
                        <ListItem button>
                          <ListItemText primary={link.text} classes={{ primary: classes.menuLink }} />
                        </ListItem>
                      </Link>
                      <Divider className={classes.divider} />
                    </React.Fragment>
                  ))}
                </List>
              </Drawer>
            </Hidden>
            <Hidden implementation="css" xsDown>
              <ul className={classes.list}>
                {links.map(link => (
                  <li key={link.href} className={classes.listItem}>
                    <Link to={link.href} className={classes.link}>
                      <Button variant="raised" color="secondary">
                        {link.text}
                      </Button>
                    </Link>
                  </li>
                ))}
              </ul>
            </Hidden>
          </div>
        </Toolbar>
      </AppBar>
    );
  }
}

export const TopNav = withStyles(styles)(TopNavBase);



// WEBPACK FOOTER //
// ./src/components/features/TopNav.tsx